<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <div class="alert alert-success" v-if="success">
                  <i class="fa fa-check"></i> Success! An email has been sent to your email address!
                </div>
                <b-form class="login" @submit.prevent="forgotPassword">
                  <h1>Forgot Password?</h1>
                  <p class="text-muted">Enter your account email below and we'll send you a confirmation email to reset your password.</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="email" name="email" class="form-control" placeholder="Email" autocomplete="email" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" name="submit" variant="primary" class="px-4">Submit</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <router-link class="btn px-0 btn-link" to="login">
                        <i class="fa fa-chevron-left"></i> Back to login
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      success: false
    }
  },
  methods: {
    /**
     * Submits email form data to backend API in order to generate a reset password email to send to the admin.
     */
    forgotPassword: function () {
      let self = this

      axios.post(`${process.env.VUE_APP_API_URL}api/admins/forgot_password`, {
        email: self.email
      })
        .then(function (response) {
          self.email = ''
          self.success = true
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
